import { render, staticRenderFns } from "./VariablesForm.vue?vue&type=template&id=31704f68&scoped=true&"
import script from "./VariablesForm.vue?vue&type=script&lang=js&"
export * from "./VariablesForm.vue?vue&type=script&lang=js&"
import style0 from "./VariablesForm.vue?vue&type=style&index=0&id=31704f68&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31704f68",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTextField } from 'vuetify/lib'
installComponents(component, {
  VTextField,
})
